import React, { useEffect, useState } from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import axios from 'axios';
import ProgressSpinner from '@avtechsoftware/react-component-library/src/components/common/ProgressSpinner';
import BillingLayout from './BillingLayout';
import BillingOverview from './BillingPage/BillingOverview';
import ServicePlanWorkflowManager from './ServicePlanWorkflowManager';
import SERVICE_PLAN_WORKFLOW_TYPE from '../../utility/types/ServicePlanWorkflowTypes';
import RaaRoute from '../common/RaaRoute';

function BillingRoutes() {
  const { path } = useRouteMatch();
  const [countryList, setCountryList] = useState(null);

  useEffect(() => {
    axios.get('/order/country-list')
      .then((r) => {
        setCountryList(r.data);
      })
      // eslint-disable-next-line no-console
      .catch((e) => console.log(e));
  }, []);

  const renderLoading = () => (
    <div className="row d-flex justify-content-center mt-5">
      <div>
        <ProgressSpinner progressText="Loading..." />
      </div>
    </div>
  );

  return (
    <BillingLayout>
      {countryList === null ? renderLoading() : (
        <Switch>
          <RaaRoute exact path={path} minimumTierLevel={0}>
            <BillingOverview countryList={countryList} />
          </RaaRoute>
          <RaaRoute path={`${path}/new-subscription`} minimumTierLevel={0}>
            <div className="container-fluid py-4">
              <ServicePlanWorkflowManager
                selectedWorkflow={SERVICE_PLAN_WORKFLOW_TYPE.NEWSUBSCRIPTION}
                countryList={countryList}
              />
            </div>
          </RaaRoute>
          <RaaRoute path={`${path}/change-plan`} minimumTierLevel={0}>
            <div className="container-fluid py-4">
              <ServicePlanWorkflowManager
                selectedWorkflow={SERVICE_PLAN_WORKFLOW_TYPE.CHANGEPLAN}
                countryList={countryList}
              />
            </div>
          </RaaRoute>
          <RaaRoute path={`${path}/change-payment-period`} minimumTierLevel={0}>
            <div className="container-fluid py-4">
              <ServicePlanWorkflowManager
                selectedWorkflow={SERVICE_PLAN_WORKFLOW_TYPE.CHANGEPAYMENTPERIOD}
                countryList={countryList}
              />
            </div>
          </RaaRoute>
          <RaaRoute path={`${path}/pay-balance`} minimumTierLevel={0}>
            <div className="container-fluid py-4">
              <ServicePlanWorkflowManager
                selectedWorkflow={SERVICE_PLAN_WORKFLOW_TYPE.PAYBALANCE}
                countryList={countryList}
              />
            </div>
          </RaaRoute>
          <RaaRoute path={`${path}/pay-in-advance`} minimumTierLevel={0}>
            <div className="container-fluid py-4">
              <ServicePlanWorkflowManager
                selectedWorkflow={SERVICE_PLAN_WORKFLOW_TYPE.PAYINADVANCE}
                countryList={countryList}
              />
            </div>
          </RaaRoute>
        </Switch>
      )}
    </BillingLayout>
  );
}

export default BillingRoutes;
